<template>
  <Icon :component="UploadSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import UploadSvg from './svg/UploadSvg.vue';

export default defineComponent({
  name: 'SelectArrowIcon',
  components: {
    Icon
  },
  data() {
    return {
      UploadSvg: markRaw(UploadSvg)
    };
  }
});
</script>
